
import Vue from "vue";

export default Vue.extend({
    name: "ModalSlide",
    props: {
        isOpen: Boolean,
        customClass: String,
        closeTrigger: Boolean       // this is the trigger that commences the leave transition
    },
    computed: {
        computedTransition () {
            return 'slide';
        }
    },
    methods: {
        afterLeave() {
            this.$emit('modal-slide-close-complete');
        }
    }
});
